
























































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import GameModule from '@/store/modules/Game';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {
    Table,
  },
})
export default class RtpAgentManagement extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Game name',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'RTP',
        attr: {
          class: 'text-left',
        },
      },
    ],
  ];

  GameInstance = getModule(GameModule, this.$store);

  data = [];

  url = '';

  rtp = 0;

  prefix = '';

  agentList: string [] = [];

  agent = '';

  created() {
    this.fetchGame();
  }

  async fetchGame() {
    await this.GeneralInstance.toggleLoading(true);
    const res = await this.GameInstance.FetchGameRtpList();
    if (res.code) {
      await this.checkError(res);
    } else {
      this.agentList = res.agent.userList;
      if (this.agent === '') {
        this.data = [];
      } else {
        const index = this.agentList.findIndex((v) => v === this.agent);
        this.data = res.agent.config[index];
      }
    }
    await this.GeneralInstance.toggleLoading(false);
  }

  async updateRTP() {
    if (this.agent !== '') {
      await this.GeneralInstance.toggleLoading(true);
      const res = await this.GameInstance.UpdateAgentRTP({
        agentId: this.data.agentId,
        config: this.data.config,
      });
      if (res.code === 0) {
        await this.checkError(res);
      } else {
        this.errorHandle(res.code, res);
      }
      await this.fetchGame();
      await this.GeneralInstance.toggleLoading(false);
    }
  }

  errorHandle(code, message) {
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });
  }

  handleChange() {
    this.fetchGame();
  }
}
